<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="title"
        :subtitle="$t('view-Home.welcome')"
        :text="$t('view-Home.welcome-text')"
      />
    </div>
    <div class="col-20">
      <div class="row d-flex justify-content-between">
        <div class="col-20 std-wrapper">
          <div class="row">
            <div class="col-20 col-lg-11 p-3 d-flex align-items-center justify-content-center">
              <img
                :src="`${$publicPath}img/dashboards/welcome.png`"
                width="739"
                height="1078"
                class="img-fluid"
              >
            </div>
            <div
              class="col-20 col-lg-9 text-col pt-5 pb-4"
              :style="`background-image: url(${$publicPath}img/dashboards/background.svg)`"
            >
              <div class="row">
                <div class="col-4" />
                <div class="col-16">
                  <div class="description-title">
                    {{ this.$t('view-Home.text.title') }}
                  </div>
                </div>
              </div>
              <div
                v-for="(item, index) in texts"
                :key="index"
                class="row description-item"
              >
                <div class="col-4 text-center">
                  <img :src="item.icon">
                </div>
                <div class="col-16">
                  <div class="description-subtitle">
                    {{ item.title }}
                  </div>
                  <div class="description-text">
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    showUnverifyAdvertiserInfo () {
      return this.$store.state.user.profile.type === 'advertiser' && this.$store.state.user.profileTypeData.verified === false
    },
    title () {
      if (this.$store.state.user.profile.type === 'influencer') {
        return `${this.$t('view-Home.hello')} ${this.$store.state.user.profileTypeData.first_name}!`
      } else {
        return `${this.$t('view-Home.hello')} ${this.$store.state.user.profile.name}!`
      }
    },
    texts () {
      let texts = []

      if (this.$store.state.user.profile.type === 'influencer') {
        texts = [
          {
            title: this.$t('view-Home.text.influencer.1.title'),
            text: this.$t('view-Home.text.influencer.1.text'),
            icon: `${this.$publicPath}img/dashboards/brain.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.2.title'),
            text: this.$t('view-Home.text.influencer.2.text'),
            icon: `${this.$publicPath}img/dashboards/search.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.3.title'),
            text: this.$t('view-Home.text.influencer.3.text'),
            icon: `${this.$publicPath}img/dashboards/campaigns.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.4.title'),
            text: this.$t('view-Home.text.influencer.4.text'),
            icon: `${this.$publicPath}img/dashboards/picture.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.5.title'),
            text: this.$t('view-Home.text.influencer.5.text'),
            icon: `${this.$publicPath}img/dashboards/dart.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.6.title'),
            text: this.$t('view-Home.text.influencer.6.text'),
            icon: `${this.$publicPath}img/dashboards/man.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.7.title'),
            text: this.$t('view-Home.text.influencer.7.text'),
            icon: `${this.$publicPath}img/dashboards/dollar.svg`
          },
          {
            title: this.$t('view-Home.text.influencer.8.title'),
            text: this.$t('view-Home.text.influencer.8.text'),
            icon: `${this.$publicPath}img/dashboards/startup.svg`
          }
        ]
      } else {
        texts = [
          {
            title: this.$t('view-Home.text.advertiser.1.title'),
            text: this.$t('view-Home.text.advertiser.1.text'),
            icon: `${this.$publicPath}img/dashboards/search.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.2.title'),
            text: this.$t('view-Home.text.advertiser.2.text'),
            icon: `${this.$publicPath}img/dashboards/campaigns.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.3.title'),
            text: this.$t('view-Home.text.advertiser.3.text'),
            icon: `${this.$publicPath}img/dashboards/dart.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.4.title'),
            text: this.$t('view-Home.text.advertiser.4.text'),
            icon: `${this.$publicPath}img/dashboards/cube.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.5.title'),
            text: this.$t('view-Home.text.advertiser.5.text'),
            icon: `${this.$publicPath}img/dashboards/brain.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.6.title'),
            text: this.$t('view-Home.text.advertiser.6.text'),
            icon: `${this.$publicPath}img/dashboards/heart.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.7.title'),
            text: this.$t('view-Home.text.advertiser.7.text'),
            icon: `${this.$publicPath}img/dashboards/circle.svg`
          },
          {
            title: this.$t('view-Home.text.advertiser.8.title'),
            text: this.$t('view-Home.text.advertiser.8.text'),
            icon: `${this.$publicPath}img/dashboards/startup.svg`
          }
        ]
      }

      return texts
    }
  }
}
</script>

<style scoped lang="scss">
  .description-title {
    font-style: normal;
    font-weight: bold;
    font-size: 0.938rem;
    line-height: 1.063rem;
  }
  .description-item {
    margin-top: 1.75rem;
    font-size: 0.688rem;
  }
  .description-subtitle{
    font-weight: 700;
  }
  .description-text {

  }
  .std-wrapper {
    padding-top: 0px;
    padding-bottom: 0px;
    overflow: hidden;
  }
  .text-col {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    @include media-breakpoint-up(lg) {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
  }
</style>
